<template>
    <footer class="footer" v-bind:class="themeClass">
        <div class="footer__row footer__row--sb">
            <ul class="footer__menu">
                <router-link class="footer__menu-item" tag="li"
                             :to="{name: 'Index', params: {lang: this.$route.params.lang}}">
                    <a>О продуктах</a>
                </router-link>
                <router-link v-if="!($route.name === 'Business')" class="footer__menu-item" tag="li"
                             :to="{name: 'Business', params: {lang: this.$route.params.lang}}">
                    <a>Бизнес кредит</a>
                </router-link>
                <router-link v-if="!($route.name === 'Micro')" class="footer__menu-item" tag="li"
                             :to="{name: 'Micro', params: {lang: this.$route.params.lang}}">
                    <a>Микрокредит</a>
                </router-link>

                <router-link class="footer__menu-item" tag="li"
                             :to="{name: 'How_to_pay_off', params: {lang: this.$route.params.lang}}">
                    <a>Как погасить</a>
                </router-link>
                <router-link class="footer__menu-item" tag="li"
                             :to="{name: 'How_to_get', params: {lang: this.$route.params.lang}}">
                    <a>Как получить</a>
                </router-link>
                <router-link class="footer__menu-item" tag="li"
                             :to="{name: 'FAQ', params: {lang: this.$route.params.lang}}">
                    <a>Вопросы и ответы</a>
                </router-link>

            </ul>
            <div class="footer__column footer__column--social">
                <p class="footer__column-text">Следите за новостями в социальных сетях</p>
                <ul class="footer__social-list">
                    <li class="footer__social-item">
                        <a href="#">
                            <img :src="imgList.facebook" alt="" class="footer__social-icon">
                        </a>
                    </li>
                    <li class="footer__social-item">
                        <a href="#">
                            <img :src="imgList.instagram" alt="" class="footer__social-icon">
                        </a>
                    </li>
                </ul>
            </div>
            <div class="footer__column footer__column--partners">
                <p class="footer__column-text">Наши партнеры</p>
                <ul class="footer__partners-list">
                    <li class="footer__partner-item">
                        <img :src="imgList.qiwi" alt="" class="footer__partner-logo footer__partner-logo--qiwi">
                    </li>
                    <li class="footer__partner-item">
                        <img :src="imgList.mastercard" alt=""
                             class="footer__partner-logo footer__partner-logo--mastercard">
                    </li>
                    <li class="footer__partner-item">
                        <img :src="imgList.visa" alt="" class="footer__partner-logo footer__partner-logo--visa">
                    </li>
                    <li class="footer__partner-item">
                        <img :src="imgList.kassa24" alt="" class="footer__partner-logo footer__partner-logo--kassa24">
                    </li>
                </ul>
            </div>
        </div>
        <div class="footer__row footer__row--sb">
            <div class="footer__registry">
                <p class="footer__registry-text">
                    <!--<router-link tag="span">-->
                    <span><a href="/rules.pdf" target="_blank">Правила предоставления микрокредитов</a></span>>
                    <!--</router-link>-->
                    <br>
                    ТОО МФО "MicroFin
                </p>
            </div>
            <div class="footer__registry">
                <p class="footer__address">
                    050070, г. Алматы, Наурызбайский район,
                    <br/>мкр. Рахат, ул. Култобе 4
                </p>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: "l-Footer",
    props: {
        theme: {
            default: "black"
        },
        about: {
            default: false
        }
    },
    data() {
        return {
            showAbout: false
        };
    },
    computed: {
        isBlackTheme() {
            return this.theme === "black";
        },
        isWhiteTheme() {
            return this.theme === "white";
        },
        themeClass() {
            return {
                "footer--black": this.isBlackTheme,
                "footer--white": this.isWhiteTheme
            };
        },
        imgList() {
            return {
                facebook: require("@/assets/svg/footer-" + this.theme + "/facebook_white.svg"),
                instagram: require("@/assets/svg/footer-" + this.theme + "/instagram_white.svg"),
                qiwi: require("@/assets/svg/footer-" + this.theme + "/qiwi_logo_Q.svg"),
                mastercard: require("@/assets/svg/footer-" + this.theme + "/mastercard.svg"),
                visa: require("@/assets/svg/footer-" + this.theme + "/visa.svg"),
                kassa24: require("@/assets/svg/footer-" + this.theme + "/kassa24.svg"),
                silkway: require("@/assets/svg/footer-" + this.theme + "/silkway.svg")
            };
        },
        toggleIcon: function() {
            return {
                "icon-top": this.showAbout,
                "icon-bottom": !this.showAbout
            };
        }
    },
    methods: {
        toggleAbout: function() {
            this.showAbout = !this.showAbout;
        }
    }
};
</script>

<style lang="scss">
@import "~@/assets/scss/variable";

.slideInDown.v-enter-to,
.slideOutDown.v-leave-to {
    animation-duration: 1s;
    animation-fill-mode: both;
}

.slideInDown.v-enter-to {
    animation-name: slideInDown;
}

.slideOutDown.v-leave-to {
    animation-name: slideOutDown;
}

@keyframes slideInDown {
    from {
        visibility: visible;
        height: 0;
        opacity: 0;
    }
    to {
        height: 578px;
        opacity: 1;
    }
}

@keyframes slideOutDown {
    from {
        height: 578px;
        opacity: 1;
    }
    to {
        height: 0;
        opacity: 0;
        visibility: hidden;
    }
}

.footer {
    padding: 35px 0 15px;

    &__row {
        max-width: 788px;
        padding: 15px 0 15px;
        width: 100%;
        margin: 0 auto 0;
        display: flex;
        justify-content: center;
    }

    &__row--sb {
        justify-content: space-between;
    }

    &__column {
        &.footer__column--partners {
            max-width: 270px;
            width: 100%;
        }

        &.footer__column--social {
            max-width: 170px;
            width: 100%;
        }
    }

    &__column-text {
        margin-bottom: 5px;
        font-family: $RobotoRegular;
        font-size: 12px;
    }

    &__holding-text {
        font-family: $RobotoRegular;
        font-size: 12px;
        margin-right: 15px;
    }

    &__holding {
        max-width: 50%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    &__holding-image {
        margin-top: 10px;
        width: 100%;
        max-width: 125px;
    }

    &__menu {
        max-width: 270px;
        display: flex;
        flex-wrap: wrap;
        list-style-type: none;
        align-items: flex-start;
        height: 100%;
    }

    &__menu-item {
        max-width: 50%;
        width: 100%;
        text-align: left;
        margin-bottom: 10px;

        a {
            font-family: $RobotoRegular;
            font-size: 14px;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    &__social-list {
        list-style-type: none;
        display: flex;
        justify-content: center;
    }

    &__social-item {
        margin: 5px;
    }

    &__social-icon {
        width: 100%;
        max-width: 30px;
    }

    &__partners-list {
        display: flex;
        list-style-type: none;
        justify-content: space-between;
        align-items: flex-start;
        max-width: 300px;
        margin-top: 15px;
        width: 100%;
        flex: 1;
    }

    &__partner-item {
    }

    &__partner-logo {
        max-width: 55px;
        width: 100%;

        &.footer__partner-logo--qiwi {
            max-width: 50px;
            width: 100%;
        }

        &.footer__partner-logo--mastercard {
            margin-top: 5px;
            max-width: 45px;
        }

        &.footer__partner-logo--visa {
            margin-top: 10px;
            max-width: 60px;
        }

        &.footer__partner-logo--kassa24 {
        }
    }

    &__registry {
        max-width: 50%;
        display: flex;
        justify-content: flex-start;
        width: 100%;
    }

    &__registry-text {
        text-align: left;
        display: inline-block;
        font-family: $RobotoRegular;
        font-size: 12px;

        span {
            a {
                font-size: 12px;
            }
        }
    }

    &__address {
        width: 100%;
        text-align: right;
        color: white;
        font-family: $RobotoRegular;
        font-size: 12px;
    }

    &__about {
        display: inline-flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: center;

        cursor: pointer;
    }

    &__about-title {
        text-align: center;
        font-family: $RobotoRegular;
        font-size: 14px;
    }

    &__about-icon {
        width: 16px;
        height: 12px;
        margin: 3px 0 0 8px;

        &.icon-top {
            transform: rotate(180deg);
        }
    }

    &__info {
        display: inline-flex;
        flex-flow: column nowrap;
        align-items: flex-start;
        justify-content: flex-start;

        width: 100%;
        text-align: left;
    }

    &__info-title {
        margin: 30px 0 36px;
        font-family: $MontserratBold;
        font-size: 30px;
        font-weight: 600;
    }

    &__info-content {
        margin-bottom: 40px;
        font-family: $RobotoRegular;
        font-size: 16px;
        line-height: 24px;
    }

    &__info-link {
        margin-bottom: 80px;
        color: $tooltip_background_blue;
        font-family: $RobotoRegular;
        font-size: 14px;
        text-decoration: underline;
    }
}

.footer--black {
    background: #303030;

    .footer__row {
        border-top: 2px solid #5d5d5d;
    }

    .footer__column-text {
        color: $white;
    }

    .footer__holding-text {
        color: $white;
    }

    .footer__menu-item {
        a {
            color: $white;
        }
    }

    .footer__registry-text {
        color: $white;

        span {
            a {
                color: $white;
            }
        }
    }

    .footer__about {
        color: $white;
    }

    .footer__info-title {
        color: $white;
    }

    .footer__info-content {
        color: $white;
    }
}

.footer--white {
    background: $white-mint;

    .footer__row {
        border-top: 2px solid #B7B7B7;
    }

    .footer__column-text {
        color: $gray-dim-dark;
    }

    .footer__holding-text {
        color: $gray-dim-dark;
    }

    .footer__menu-item {
        a {
            color: $gray-dim-dark;
        }
    }

    .footer__registry-text {
        color: $gray-dim-dark;

        span {
            a {
                color: $gray-dim-dark;
            }
        }
    }

    .footer__about {
        color: $gray-dim-dark;
    }

    .footer__info-title {
        color: $purple-site;
    }

    .footer__info-content {
        color: $gray-dim-dark;
    }
}

@media screen and (max-width: 820px) {
    .footer {
        padding: 35px 15px;
    }
}

@media screen and (max-width: 780px) {
    .footer--white {
        display: none;
    }
}

@media screen and (max-width: 740px) {
    .footer {
        &__row {
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        &__menu {
            max-width: 100%;
        }

        &__column {
            margin-top: 20px;
        }

        &__social-list {
            justify-content: center;
        }

        &__menu-item {
            max-width: 33.33333%;
            width: 100%;
            text-align: center;
            margin-bottom: 10px;

            a {
                font-family: $RobotoRegular;
                color: $white;
                font-size: 14px;
                text-decoration: none;
            }
        }

        &__holding {
            max-width: 100%;
            display: flex;
            flex-direction: column;
        }

        &__holding-image {
            max-width: 170px;
        }

        &__registry {
            justify-content: center;
            text-align: center;
            margin-top: 30px;
            max-width: 100%;

            span {
                display: block;
            }
        }

        &__registry-text {
            line-height: 1.5;
            text-align: center;

            br {
                display: none;
            }
        }


        &__address {
            text-align: center;
        }
    }
}

@media screen and (max-width: 460px) {
    .footer {
        &__row {
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        &__menu {
            max-width: 100%;
        }

        &__column {
            margin-top: 20px;
        }

        &__social-list {
            justify-content: flex-start;
        }

        &__column.footer__column--partners {
            max-width: 100%;
        }

        &__column.footer__column--social {
            max-width: 100%;
        }

        &__column-text {
            text-align: left;
        }

        &__menu-item {
            max-width: 100%;
            width: 100%;
            text-align: left;
            margin-bottom: 10px;
        }
    }
}
</style>
